const maskString = (string, visibleChars) => {
  const stringLength = string.length;
  if (stringLength > visibleChars) {
    const maskedChars = stringLength - visibleChars;
    return `${"*".repeat(maskedChars)}${string.slice(-visibleChars)}`;
  } else return `${"*".repeat(stringLength)}`;
};

export default maskString;
